export const COMPONENT_TYPE_CL = 'generate-cover-letter';
export const WIZARD_TEXT =
  'Wizard at work: Crafting your Cover Letter from Resume...';
export const GENERATE_CL_ERROR_MSG = 'Failed to generate cover letter';
export const WIZARD_STATUS_DONE = 'done';
export const WIZARD_STATUS_DEFAULT = 'default';
export const GENERATE_CL_POPUP = 'generateCLPopup';
export const JOB_SPECIFIC = 'jobSpecific';
export const SAMPLE_COVER_LETTER = 'sampleCoverLetter';
export const JOB_TITLE = 'Job Title';
export const JOB_LOCATION = 'Job Location';
export const ORGANIZATION_NAME = 'Organization';
export const JOB_DESCRIPTION = 'Job Description';
